import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string | undefined;
  elevated?: boolean | undefined;
}

export function Card({ children, className, elevated = false }: CardProps): JSX.Element {
  return (
    <div
      className={cx(
        "rounded-lg border border-border bg-surface p-4",
        elevated ? "shadow-elevated" : "shadow-soft",
        className,
      )}
    >
      {children}
    </div>
  );
}

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
